<template>
  <div class="H5Container">
      <b-container class='WXContainer bottomBorder text-center'>
        <slot name="title"></slot>
      </b-container>
      <b-container class='WXContainer text-center'>
        <slot name="body"></slot>
      </b-container>
    </div>
</template>
<script type="text/javascript">
export default {
  name: 'WXContainer',
  props: {},
  data() {
    return {

    }
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {},
}

</script>
<style type="text/css">
.WXContainer {
  background: white;
  padding: 12px 16px;
}

</style>




// WEBPACK FOOTER //
// src/components/WEUI/WXContainer.vue